export const releases = [
	{
		version: '1.3.1',
		date: '2023-12-01',
		description: `Color-coding for multiple riders`,
		newFeatures: null,
		bugFixes: ['Fixed color-coding for multiple riders on order details page'],
		perfImprovements: null,
		otherChanges: null,
	},
	{
		version: '1.3.0',
		date: '2023-11-29',
		description: `Notifications, call logs, and special instructions`,
		newFeatures: [`Desktop notifications for new chat messages`, `Call logs on order details page`, `Special instructions on order details page`],
		bugFixes: null,
		perfImprovements: null,
		otherChanges: null,
	},
	{
		version: '1.2.1',
		date: '2023-11-13',
		description: `Chatroom Bug Fixes`,
		newFeatures: null,
		bugFixes: ['Fixed order information & link on chatrooms from support chat list'],
		perfImprovements: null,
		otherChanges: null,
	},
	{
		version: '1.2.0',
		date: '2023-11-06',
		description: `Order information & link on chatrooms`,
		newFeatures: [
			'Added order information (external ID, consumer, producer, and source) as well as link to order details page on chatrooms',
		],
		bugFixes: null,
		perfImprovements: null,
		otherChanges: null,
	},
	{
		version: '1.1.0',
		date: '2023-10-30',
		description: `Chat notifications`,
		newFeatures: [
			'Added real-time chat notifications on sidebar, active orders, order history, and order detail views',
		],
		bugFixes: null,
		perfImprovements: null,
		otherChanges: null,
	},
	{
		version: '1.0.0',
		date: '2023-10-17',
		description: `Order History & Search`,
		newFeatures: [
			'Added Order History Page to search orders by date and/or fuzzy search by keywords',
			'Added toggle to view all, active or inactive chats in Support Chats Page',
		],
		bugFixes: [
			'Sorted orders and search results saved when navigating away from active orders & order history pages',
		],
		perfImprovements: null,
		otherChanges: null,
	},
];